import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=0b7d4734"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=0b7d4734&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.servis.leaseplan.cz/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7d4734')) {
      api.createRecord('0b7d4734', component.options)
    } else {
      api.reload('0b7d4734', component.options)
    }
    module.hot.accept("./LangSwitcher.vue?vue&type=template&id=0b7d4734", function () {
      api.rerender('0b7d4734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/global/LangSwitcher.vue"
export default component.exports